import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-blue-600 p-2 rounded-lg">
                <Package className="h-6 w-6" />
              </div>
              <div className="text-xl font-bold" style={{ fontFamily: 'Space Grotesk' }}>DC PAC LLC</div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Premium paper hot cups and disposable packaging supplier for B2B customers.
            </p>
            <p className="text-gray-400 text-sm font-semibold">Value. Built In.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => {
                    const element = document.getElementById('quote-section');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                      window.location.href = '/#quote-section';
                    }
                  }}
                  className="text-gray-400 hover:text-white transition-colors text-left"
                >
                  Request Quote
                </button>
              </li>
              <li>
                <a 
                  href="https://customer-assets.emergentagent.com/job_b2b-packaging-1/artifacts/8kw17atq_POS%20Cups%20-%20Spec%20Sheet%20%281%29.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Download Spec Sheet
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-bold mb-4">Products</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>POS Cups&trade; Series</li>
              <li>HC White Hot Cups</li>
              <li>8oz to 24oz Sizes</li>
              <li>Bulk Ordering</li>
              <li>Pallet Orders</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-gray-400 text-sm">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span>6 Kilmer Rd #1118<br />Edison, NJ 08817</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5" />
                <a href="tel:732-997-0792" className="text-gray-400 hover:text-white transition-colors">
                  732-997-0792
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5" />
                <a href="mailto:info@dcpac.co" className="text-gray-400 hover:text-white transition-colors">
                  info@dcpac.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} DC PAC LLC. All rights reserved.</p>
          <p className="mt-2">
            <a href="https://dcpac.co" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              DCPac.co
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;